import { useAutoneTranslation } from '@autone/translations';
import { useState } from 'react';

import { type FullScreenContainer } from '../../types';

import { usePeakViewData } from './hooks/usePeakViewData';
import PeakViewTooltip from './peak-view-tooltip/PeakViewTooltip';

export const PeakViewTooltipButton = ({
  productId,
  isFullScreen,
  fullScreenContainer,
  deprecatedFullscreenContainer,
  isHovered = true,
}: {
  productId: string;
  isFullScreen?: boolean;
  fullScreenContainer?: HTMLDivElement | null;
  /**
   * @deprecated Use fullScreenContainer prop instead
   */
  deprecatedFullscreenContainer?: FullScreenContainer;
  isHovered?: boolean;
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const { common } = useAutoneTranslation();
  const {
    isLoading,
    priceTypes,
    defaultCurrency,
    department,
    subDepartment,
    material,
    season,
    event,
    firstSale,
    lifeToDateSales,
    gender,
  } = usePeakViewData({
    productId,
    skipQuery: !isOpen,
  });

  return (
    <div className={isHovered ? 'opacity-100' : 'opacity-0'}>
      <PeakViewTooltip
        isHovered={isHovered}
        isLoading={isLoading}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        priceTypes={priceTypes}
        defaultCurrency={defaultCurrency}
        department={department}
        subDepartment={subDepartment}
        season={season}
        event={event}
        material={material}
        gender={gender}
        firstSale={firstSale}
        lifeToDateSales={
          lifeToDateSales != null
            ? common.withValue('units', {
                count: lifeToDateSales,
                value: lifeToDateSales,
              })
            : undefined
        }
        isFullScreen={isFullScreen}
        fullScreenContainerElement={fullScreenContainer}
        fullScreenContainer={deprecatedFullscreenContainer}
      />
    </div>
  );
};
